export function prepareQuestionImageUrl(url: string, height: number) {
  return `${url}?h=${height}`;
}
